module.exports = __webpack_public_path__ + "img/category-research.7a224ab4.svg";